import React, { useState, useRef } from "react";
import { Button, Form } from "react-bootstrap";
import Modal from "react-bootstrap/Modal";
import bellIcon from "../assets/img/bell.svg";
import userIcon from "../assets/img/media_icon6.png";
import mailIcon from "../assets/img/gmail_icon.svg";
import shieldIcon from "../assets/img/shield-alt_icon.svg";
// import "./style.css";
import { toast } from "react-toastify";
import { config } from "../config";
export default function WaitlistPopup({ showModel, setShowModel, initialEmail = "" }) {
  const [form, setForm] = useState({ name: "", email: initialEmail, phone: "" });
  const [error, setError] = useState({ name: "", email: "", phone: "" });
  const emailRef = useRef(null);
  const phoneRef = useRef(null);

  // Enter advances to the next field instead of submitting the form.
  const focusNext = (e, ref) => {
    if (e.key === "Enter") {
      e.preventDefault();
      ref.current?.focus();
    }
  };

  // Chrome fires the lhAutofillStart animation on autofill (see popup.scss).
  // Mark the wrapper so the icon can go black on the light autofill background.
  const onAnimStart = (e) => {
    if (e.animationName === "lhAutofillStart") {
      e.currentTarget.closest(".popup-input")?.classList.add("is-autofilled");
    }
  };
  // Once the user edits, it's no longer autofilled → restore the white icon.
  const clearAutofilled = (e) => {
    e.currentTarget.closest(".popup-input")?.classList.remove("is-autofilled");
  };

  const handleClose = () => {
    setShowModel(false);
  };

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const isValidEmail = (email) =>
    /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

  // UK mobile: must start 07 and be exactly 11 digits
  const isValidUkMobile = (val) => /^07\d{9}$/.test(val);

  const validate = () => {
    const next = { name: "", email: "", phone: "" };
    if (form.name == "") next.name = "Name is required";
    else if (form.name.length < 3)
      next.name = "Name must be at least 3 characters";

    if (form.email == "") next.email = "Email is required";
    else if (!isValidEmail(form.email)) next.email = "Enter a valid email";

    // phone optional — only validate format if something was entered
    if (form.phone != "" && !isValidUkMobile(form.phone))
      next.phone = "Enter a valid UK mobile number (07xxxxxxxxx)";

    setError(next);
    return next.name == "" && next.email == "" && next.phone == "";
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (validate()) {
      let res = await fetch(`${config.serverApi}/createWaitlist`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(form),
      });
      res = await res.json();
      console.log(res);

      if (res.Status == 201) {
        toast.success("Thanks for joining the waitlist, we’ll keep you posted!", {
          autoClose: 6000,
        });
        handleClose();
      } else {
        toast.error(res.Message || "Something went wrong. Please try again.", {
          autoClose: 6000,
        });
      }
    }
  };

  return (
    <>
      <Modal
        show={showModel}
        onHide={() => setShowModel(false)}
        centered
        className="waitlist-modal"
      >
        <Modal.Header closeButton></Modal.Header>

        <Modal.Body>
          <div className="popup-bell">
            <img src={bellIcon} alt="" />
          </div>
          <h2>Join the <span>Waitlist</span></h2>
          <p className="popup-sub">Be among the first 1000 to get free access. We’ll notify you when we’re ready to go live.</p>
          <Form onSubmit={handleSubmit}>
            <Form.Group className="mb-3">
              <div className="popup-input">
                <span className="popup-input-icon">
                  <img src={userIcon} alt="" />
                </span>
                <Form.Control
                  type="text"
                  placeholder="Name"
                  name="name"
                  autoComplete="off"
                  value={form.name}
                  onAnimationStart={onAnimStart}
                  onChange={(e) => {
                    clearAutofilled(e);
                    if (e.target.value == "") {
                      setError({ ...error, name: "Name is required" });
                    } else if (e.target.value.length < 3) {
                      setError({
                        ...error,
                        name: "Name must be at least 3 characters",
                      });
                    } else {
                      setError({ ...error, name: "" });
                    }
                    handleChange(e);
                  }}
                  onKeyDown={(e) => focusNext(e, emailRef)}
                  // required
                />
              </div>
              {error.name && (
                <p style={{ color: "red", fontSize: "13px", marginTop: "5px", textAlign: 'left' }}>
                  {error.name}
                </p>
              )}
            </Form.Group>
            <Form.Group className="mb-3">
              <div className="popup-input">
                <span className="popup-input-icon">
                  <img src={mailIcon} alt="" />
                </span>
                <Form.Control
                  ref={emailRef}
                  type="email"
                  placeholder="Email"
                  name="email"
                  autoComplete="off"
                  value={form.email}
                  onAnimationStart={onAnimStart}
                  onChange={(e) => {
                    clearAutofilled(e);
                    const isValidEmail = (email) =>
                      /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
                    if (e.target.value == "") {
                      setError({ ...error, email: "Email is required" });
                    } else if (!isValidEmail(e.target.value)) {
                      setError({ ...error, email: "Enter a valid email" });
                    } else {
                      setError({ ...error, email: "" });
                    }
                    handleChange(e);
                  }}
                  onKeyDown={(e) => focusNext(e, phoneRef)}
                  // required
                />
              </div>
              {error.email && (
                <p style={{ color: "red", fontSize: "13px", marginTop: "5px", textAlign: 'left' }}>
                  {error.email}
                </p>
              )}
            </Form.Group>
            <Form.Group className="mb-3">
              <div className="popup-input">
                <span className="popup-input-icon">
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                    <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.13.96.36 1.9.7 2.81a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.91.34 1.85.57 2.81.7A2 2 0 0 1 22 16.92z" />
                  </svg>
                </span>
                <Form.Control
                  ref={phoneRef}
                  type="tel"
                  autoComplete="off"
                  inputMode="numeric"
                  pattern="[0-9]*"
                  maxLength={11}
                  placeholder="Phone Number"
                  name="phone"
                  value={form.phone}
                  onAnimationStart={onAnimStart}
                  onChange={(e) => {
                    clearAutofilled(e);
                    const clean = e.target.value.replace(/\D/g, "").slice(0, 11);
                    if (clean == "" || isValidUkMobile(clean)) {
                      setError({ ...error, phone: "" });
                    } else {
                      setError({
                        ...error,
                        phone: "Enter a valid UK mobile number (07xxxxxxxxx)",
                      });
                    }
                    setForm({ ...form, phone: clean });
                  }}
                />
              </div>
              {error.phone && (
                <p style={{ color: "red", fontSize: "13px", marginTop: "5px", textAlign: 'left' }}>
                  {error.phone}
                </p>
              )}
            </Form.Group>
            <Button type="submit" className="w-100 notify-btn">
              <svg className="notify-btn-plane" viewBox="0 0 24 24" aria-hidden="true">
                <path d="M22 2 11 13" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M22 2 15 22l-4-9-9-4 20-7z" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
              Notify Me
            </Button>
            {/* <p className="popup-footnote">
              <img src={shieldIcon} alt="" /> No spam. Unsubscribe anytime.
            </p> */}
          </Form>
        </Modal.Body>
      </Modal>
    </>
  );
}
